import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from './actionTypes';

const initialState = {
  error: '',
  loading: false,
  user: JSON.parse(localStorage.getItem('authUser')),
};

// eslint-disable-next-line default-param-last
const login = (state = initialState, action) => {
  let nstate = {};

  switch (action.type) {
    case LOGIN_USER:
      nstate = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      nstate = {
        ...state,
        loading: false,
        user: action.payload.user,
      };
      break;
    case LOGOUT_USER:
      nstate = {
        ...state,
      };
      break;
    case LOGOUT_USER_SUCCESS:
      nstate = {
        ...state,
        user: {
          roles: ['guest'],
        },
      };
      break;
    case API_ERROR:
      nstate = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    default:
      nstate = {
        ...state,
      };
      break;
  }
  return nstate;
};

export default login;
